export default __webpack_public_path__ + "static/media/GT-America-Mono-Regular.1dc10b5a.woff";